import ReactGridLayout, { useContainerWidth } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import { GripHorizontal, X } from "lucide-react";
import { IDS } from "../constants/testIds";

export const ROW_H = 40;
export const DEFAULT_LAYOUT = [
  { i: "roster",   x: 0, y: 0,  w: 2, h: 16, minW: 2, minH: 6 },
  { i: "channels", x: 2, y: 0,  w: 5, h: 16, minW: 3, minH: 6 },
  { i: "map",      x: 7, y: 0,  w: 5, h: 16, minW: 2, minH: 5 },
  { i: "alerts",   x: 7, y: 16, w: 5, h: 6,  minW: 2, minH: 4 },
  { i: "logger",   x: 0, y: 16, w: 7, h: 6,  minW: 4, minH: 5 },
];
export const PANE_TITLES = { roster: "Field Units", channels: "Channels", map: "Live Location", alerts: "Emergencies", logger: "Audio Logger" };

export default function DashboardGrid({ layout, onLayoutChange, locked, panes, hidden = [], onHide }) {
  const { width, containerRef, mounted } = useContainerWidth();
  const visible = layout.filter(l => !hidden.includes(l.i));
  return (
    <div ref={containerRef} data-testid={IDS.layout.grid} className={`px-4 md:px-6 pb-8 ${locked ? "" : "layout-editing"}`}>
      {mounted && (
        <ReactGridLayout
          layout={visible}
          width={width}
          gridConfig={{ cols: 12, rowHeight: ROW_H, margin: [16, 16], containerPadding: [0, 16] }}
          dragConfig={{ enabled: !locked, handle: ".pane-handle" }}
          resizeConfig={{ enabled: !locked, handles: ["se", "s", "e"] }}
          onLayoutChange={onLayoutChange}
        >
          {visible.map(({ i }) => (
            <div key={i} data-testid={IDS.layout.pane(i)} className="pane flex flex-col min-h-0">
              <div data-testid={IDS.layout.handle(i)} className={`pane-handle flex items-center gap-2 h-6 px-2 -mb-1 text-[10px] font-mono uppercase tracking-widest rounded-t-lg select-none border ${locked ? "text-slate-400 bg-transparent border-transparent" : "cursor-grab active:cursor-grabbing text-amber-700 bg-amber-50 border-amber-200"}`}>
                {!locked && <GripHorizontal className="h-3.5 w-3.5" />}
                <span className="flex-1 truncate">{PANE_TITLES[i]}</span>
                <button data-testid={IDS.layout.close(i)} onClick={() => onHide(i)} onPointerDown={e => e.stopPropagation()} className="h-5 w-5 grid place-items-center rounded hover:bg-slate-200/60 hover:text-slate-900 transition" aria-label={`Close ${PANE_TITLES[i]} pane`} title="Close pane (reopen from Panes menu)">
                  <X className="h-3.5 w-3.5" />
                </button>
              </div>
              <div className="flex-1 min-h-0">{panes[i]}</div>
            </div>
          ))}
        </ReactGridLayout>
      )}
      {visible.length === 0 && (
        <div className="py-16 text-center text-sm text-slate-500">All panes are hidden. Use the <b>Panes</b> menu in the header to show them.</div>
      )}
    </div>
  );
}
